export default __webpack_public_path__ + "static/media/ic-empty-query.947996ab.svg";